/**
 * Created by netre on 27.06.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { translate } from 'react-i18next';

import {
  clearTooltip,
  setTooltip,
} from '../../../sagas/devices/actions';
import { setWebasto, setWebastoPeriodClick } from '../../Sidebar/actions';
import { WebastoTimer } from './WebastoTimer';

@connect(
  state => ({
    webastoOn: state.devices.currentDeviceStats.webastoOn,
    deviceId: state.devices.currentDevice.id,
    currentDevice: state.devices.currentDevice,
  }),
  dispatch => ({
    setTooltip({ type }) {
      return dispatch(setTooltip({ type }));
    },
    clearTooltip() {
      return dispatch(clearTooltip());
    },
    toggleWebasto({ deviceId, on }) {
      return dispatch(setWebasto({ deviceId, on }));
    },
    handleWebastoDelayInSeconds({ deviceId, seconds }) {
      return dispatch(setWebastoPeriodClick({ deviceId, seconds }));
    },
  }),
)
@translate(['dashboard-sidebar'], { wait: true })
export class WebastoButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      webastoMenuOpened: false,
    };
  }

  onAutorunClickOutside = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target !== this.openAutorunBtn) {
      this.setState({
        webastoMenuOpened: false,
      });
    }
  };

  setWebastoOn = (e) => {
    this.props.toggleWebasto({
      deviceId: this.props.currentDevice.id,
      on: e.target.checked,
    });
  };

  setSeconds = (e, decrease = false) => {
    e.preventDefault();
    const minutes = Math.round(this.props.currentDevice.webastoPeriodInSeconds / 60);
    if ((minutes === 2 && decrease) || (minutes === 30 && !decrease)) return;
    let newSeconds = (minutes + (((-1) ** (Number(decrease))) * 5)) * 60;
    if (newSeconds > 1800) newSeconds = 1800;
    if (newSeconds < 120) newSeconds = 120;
    if (minutes === 2 && !decrease) newSeconds = 300;
    this.props.handleWebastoDelayInSeconds({
      deviceId: this.props.currentDevice.id,
      seconds: newSeconds,
    });
  };

  clickHandler = (e) => {
    e.preventDefault();
    clearInterval(this.animationInterval);
  };

  mouseDownHandler = (e) => {
    const { handleAnimationState, toggleWebasto } = this.props;
    e.preventDefault();
    if (e.target !== this.openAutorunBtn) {
      handleAnimationState(true);
      this.progress = 0;

      this.animationInterval = setInterval(() => {
        this.progress += 1;
        if (this.progress > 99) {
          this.progress = -1;
          clearInterval(this.animationInterval);
          toggleWebasto({
            deviceId: this.props.deviceId,
            on: this.props.webastoOn,
          });
          handleAnimationState(false);
        }
      }, 3000 / 100);
    }
  };
  mouseUpHandler = (e) => {
    e.preventDefault();
    clearInterval(this.animationInterval);
    this.props.handleAnimationState(false);
  };
  render() {
    const { t, webastoOn, currentDevice } = this.props;
    const { webastoMenuOpened } = this.state;
    const containerClass = cx('control-panel__button', {
      'aside__drop-down--open': webastoMenuOpened,
      'control-panel__button_shape_quadratic': this.props.quadratic,
    });
    const buttonClass = cx('control-button', 'control-button_type_warmup', {
      'control-button_state_active': webastoOn,
      'control-button_shape_quadratic': this.props.quadratic,
    });

    return (
      <div className={containerClass}>
        <div
          className={buttonClass}
          onMouseDown={this.mouseDownHandler}
          onMouseUp={this.mouseUpHandler}
          onClick={this.clickHandler}
        >
          <span className="control-button__icon" />
          {webastoOn && <div className="control-button__text">{t('dashboard-sidebar:webastoOff')}</div> }
          {(!webastoOn) && <div className="control-button__text">
            {t('dashboard-sidebar:webastoOn')}
            <div
              role="button"
              tabIndex={0}
              ref={(btn) => { this.openAutorunBtn = btn; }}
              onClick={(e) => {
                e.preventDefault();
                this.setState({ webastoMenuOpened: !this.state.webastoMenuOpened });
              }}
              className="control-button__hint hint"
            >
              <span className="right" style={{ zIndex: 1 }}>
                {t('dashboard-sidebar:preheating')}
              </span>
            </div>
          </div>
          }
        </div >
        {this.state.webastoMenuOpened &&
        <WebastoTimer
          setWebastoOn={this.setWebastoOn}
          setSeconds={this.setSeconds}
          onClickOutside={this.onAutorunClickOutside}
          currentDevice={currentDevice}
        />}
      </div>
    );
  }
}

WebastoButton.propTypes = {
  handleAnimationState: PropTypes.func.isRequired,
  quadratic: PropTypes.bool.isRequired,
};

WebastoButton.WrappedComponent.propTypes = {
  deviceId: PropTypes.number.isRequired,
  webastoOn: PropTypes.bool.isRequired,
  currentDevice: PropTypes.shape({
    id: PropTypes.number,
    webastoPeriodInSeconds: PropTypes.number,
  }).isRequired,
  toggleWebasto: PropTypes.func.isRequired,
  handleWebastoDelayInSeconds: PropTypes.func.isRequired,
  clearTooltip: PropTypes.func.isRequired,
  setTooltip: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/Webasto/index.js